<div>
  <ng-template ngFor let-button [ngForOf]="buttons">
    <ng-template
      [ngIf]="button.title === 'ProcessLog'"
      [ngIfElse]="otherButton"
    >
      <button
        pButton
        class="p-content-button p-mr-1"
        [ngStyle]="button.style!"
        [ngClass]="button.styleClass!"
        [icon]="button.icon!"
        [label]="
          !isShowProcessLog
            ? ('SigvLibrary.ShowTrackingRecords' | translate)
            : ('SigvLibrary.HideTrackingRecords' | translate)
        "
        (click)="buttonClickHandler($event, button.title)"
      ></button>
    </ng-template>
    <ng-template #otherButton>
      <button
        pButton
        class="p-content-button p-mr-1"
        [ngStyle]="button.style!"
        [ngClass]="button.styleClass!"
        [icon]="button.icon!"
        [disabled]="button.disabled"
        [label]="
          (button.state?.translateKey ? button.state?.translateKey : '')
            | translate
        "
        (click)="buttonClickHandler($event, button.title)"
      ></button>
    </ng-template>
  </ng-template>
  <p-splitButton
    *ngIf="moreButtons.length > 0"
    #ua
    label="{{ 'SigvLibrary.More' | translate }}"
    [model]="moreButtons"
    class="cfc-splitbutton"
    (onClick)="ua.onDropdownButtonClick($event)"
  >
  </p-splitButton>
</div>
